<div #anchor class="date-range-picker">
	<div class="from-date">
		<label style="margin-bottom: 0px" [ngClass]="{'disabled': disabled}">{{'from' | cpLabelTranslate}}:</label>
			<kendo-datepicker
					[ngClass]="{'kendo-date-picker-error': !validDateRange}"
					[class.hijri-date]="showHijri"
					[format]="showHijri ? ((hijriDateService.hijriDatesObservable | async) | cpHijriDate: fromDate) : 'Full'"
					[value]="fromDate"
					[max]="toDate"
					[disabled]="disabled"
					[readOnlyInput]="showHijri"
					[popupSettings]="{popupClass:'hijri-date2'}"
					(open)="open.emit()"
					(close)="close.emit()"
					(valueChange)="handleSelectionFromChange($event); dateRangeValidation()">
				<ng-container *ngIf="showHijri">
					<ng-template kendoCalendarHeaderTitleTemplate let-date="date"
								 let-title
								 let-view="activeView">
						<span class="custom title">
								{{title}}
							<div  class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: date: "": view }}</div>
						</span>
					</ng-template>

					<ng-template kendoCalendarCellTemplate let-dateInCell>
						<span class="custom">
								{{dateInCell | cpDate: "DayOfMonth"}}
							<div class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: dateInCell: "iD"}}</div>
						</span>
					</ng-template>

					<ng-template kendoCalendarYearCellTemplate let-context="cellContext">
						<span class="custom">
								{{context.formattedValue}}
							<div class="hijri-date" style="height: 55px;">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: context.value: "iMMMM":"month"}}</div>
						</span>
					</ng-template>

					<ng-template kendoCalendarDecadeCellTemplate let-context="cellContext">
						<span class="custom">
								{{context.formattedValue}}
							<div class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: context.value: "iYYYY":"year"}}</div>
						</span>
					</ng-template>
				</ng-container>
			</kendo-datepicker>
	</div>
	<div class="to-date" >
		<label style="margin-bottom: 0px" [ngClass]="{'disabled': disabled}">{{'to' | cpLabelTranslate}}:</label>
			<kendo-datepicker
					#todatepicker
					[ngClass]="{'kendo-date-picker-error': !validDateRange}"
					[class.hijri-date]="showHijri"
					[format] ="showHijri ? ((hijriDateService.hijriDatesObservable | async) | cpHijriDate: toDate) : 'Full'"
					[value]="toDate"
					[min]="fromDate"
					[disabled]="disabled"
					[readOnlyInput]="showHijri"
					[popupSettings]="{popupClass:'hijri-date2'}"
					(open)="open.emit()"
					(close)="close.emit()"
					(valueChange)="handleSelectionToChange($event); dateRangeValidation()">
				<ng-container *ngIf="showHijri">
					<ng-template kendoCalendarHeaderTitleTemplate let-date="date"
								 let-title
								 let-view="activeView">
						<span class="custom title">
								{{title}}
							<div  class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: date: "": view }}</div>
						</span>
					</ng-template>

					<ng-template kendoCalendarCellTemplate let-dateInCell>
						<span class="custom">
								{{dateInCell | cpDate: "DayOfMonth"}}
							<div class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: dateInCell: "iD"}}</div>
						</span>
					</ng-template>

					<ng-template kendoCalendarYearCellTemplate let-context="cellContext">
						<span class="custom">
								{{context.formattedValue}}
							<div class="hijri-date" style="height: 55px;">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate:context.value: "iMMMM":"month"}}</div>
						</span>
					</ng-template>

					<ng-template kendoCalendarDecadeCellTemplate let-context="cellContext">
						<span class="custom">
								{{context.formattedValue}}
							<div class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: context.value: "iYYYY":"year"}}</div>
						</span>
					</ng-template>
				</ng-container>
			</kendo-datepicker>
	</div>
</div>
